import React from 'react';
import { fetchHydra as baseFetchHydra, hydraDataProvider as baseHydraDataProvider } from '@api-platform/admin';
import { Redirect, Route } from 'react-router-dom';
import { parseHydraDocumentation } from '@api-platform/api-doc-parser';

const fetchHydra = (url, options = {}) => {
  return baseFetchHydra(url, {
    ...options,
    credentials: 'include',
  });
};

export const apiDocumentationParser = (entrypoint) =>
  parseHydraDocumentation(entrypoint, { credentials: 'include' }).then(
    ({ api }) => ({ api }),
    (result) => {
      switch (result.status) {
        case 401:
          return Promise.resolve({
            api: result.api,
            customRoutes: [
              <Route
                path="/"
                render={() => {
                  return <Redirect to="/login"/>;
                }}
              />,
            ],
          });

        default:
          return Promise.reject(result);
      }
    },
  );

export const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;

export const dataProvider = baseHydraDataProvider(entrypoint, fetchHydra, apiDocumentationParser);

export const sendCustomApiRequest = (path, data, options = {}) => {
  const form_data = new FormData();

  Object.entries(data).forEach(([key, value]) => form_data.append(key, value));

  /** @type {RequestInit} */
  const requestData = {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    redirect: 'follow',
    credentials: 'include',
    ...options,
  };

  if (['GET', 'HEAD'].includes(requestData.method) === false) {
    requestData.body = form_data;
  }

  return fetch(entrypoint + path, requestData);
};
